// Für volle API-Dokumentation, einschließlich Codebeispiele, besuchen Sie http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function gallery1_mouseIn(event, $w) {
	//Add your code for this event here: 
}